import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './services/auth-service/auth.service';
import { map, Observable } from 'rxjs';

export const authGuard: CanActivateFn =
  (/*route, state*/): Observable<boolean> => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.isAuthenticated().pipe(
      map((isAuthenticated) => {
        if (!isAuthenticated) {
          router.navigate(['/auth/login']);
          return false;
        }
        return true;
      }),
    );
  };
